import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
export function TicketQR() {
  return <div className="bg-white p-6 rounded-3xl shadow-lg border border-gray-100 flex flex-col items-center space-y-4" data-id="element-111">
      <div className="bg-white p-2 rounded-xl border-2 border-dashed border-gray-300" data-id="element-112">
        <QRCodeSVG value="https://oneticket.bd/ticket/123456" size={200} data-id="element-113" />
      </div>
      <div className="text-center" data-id="element-114">
        <p className="text-sm text-gray-500 font-bengali" data-id="element-115">
          স্ক্যান করার জন্য এটি দেখান
        </p>
        <p className="font-mono text-lg font-bold tracking-widest mt-1 text-gray-800" data-id="element-116">
          TKT-8392-BD
        </p>
      </div>
    </div>;
}